import PropTypes from 'prop-types'
// NOTE: Stateful: local state, not Redux state!

import React from 'react'
import Link from 'components/Link'
import cx from 'classnames'
import classes from './Button.scss'
import Spinner from 'components/Spinner'
import Sticky from 'components/Sticky'

export const Button = React.createClass({
  propTypes: {
    stick: PropTypes.bool,
    stickOptions: PropTypes.object,

    children: PropTypes.node,
    message: PropTypes.string,
    callback: PropTypes.func,
    confirm: PropTypes.bool,
    onlyOnce: PropTypes.bool,
    disabled: PropTypes.bool,
    submit: PropTypes.bool,
    submitting: PropTypes.bool,
    options: PropTypes.array,
    href: PropTypes.string, // href/to are the same, both are <Link />s
    to: PropTypes.string, // href/to are the same, both are <Link />s
    element: PropTypes.string, // HTML Element button|a|Link (a=Link)

    htmlFor: PropTypes.string,
    role: PropTypes.string,
    tabIndex: PropTypes.number
  },

  getDefaultProps: () => ({
    stick: false,
    stickOptions: {},
    role: 'button',

    confirm: false,
    onlyOnce: true,
    disabled: false,
    submit: false,
    options: [],
    element: 'button' // HTML Element button|a|Link (a=Link)
  }),

  // NOTE: confirm and submit don't work together
  getInitialState: function () {
    return { confirming: false, completed: false }
  },

  componentWillUnmount: function () {
    if (this.toggleTimer) {
      clearTimeout(this.toggleTimer)
      delete this.toggleTimer
    }

    if (this.resetConfirmationTimer) {
      clearTimeout(this.resetConfirmationTimer)
      delete this.resetConfirmationTimer
    }
  },

  setCompleted: function (status = true) {
    if (this.props.onlyOnce) {
      if (this.resetConfirmationTimer) clearTimeout(this.resetConfirmationTimer)

      this.setState({ completed: status })

      // after 5 seconds, allow it to be clicked again
      if (status === true) this.resetConfirmationTimer = setTimeout(() => { this.setCompleted(false) }, 5000)
    }
  },

  toggle: function (status) {
    if (this.toggleTimer) clearTimeout(this.toggleTimer)
    if (status === undefined) status = !this.state.confirming

    this.setState({ confirming: status })

    if (status === true) this.toggleTimer = setTimeout(() => { this.toggle(false) }, 2500)
  },

  // NOTE: 90% of this function is repetitive with renderConfirmation
  renderButton: function () {
    let elementName = this.props.element && typeof this.props.element.toLowerCase === 'function' && this.props.element.toLowerCase() ||
      this.props.element

    const disabledOrCompleted = this.props.disabled || this.state.completed || this.props.submitting
    const confirming = !!this.state.confirming
    const canComplete = !disabledOrCompleted && (!this.props.confirm || confirming) // can do the final action (ie. )
    const classBase = confirming && 'confirmation' || 'button'
    let contents = confirming && (this.props.message || 'Are you sure?') || this.props.children
    if (this.props.submitting) { // wrap in a div and add a spinner to it!
      contents = <div className={classes['spinner-wrapper']}>
        {[ <Spinner className={classes.spinner} />, contents ]}
      </div>
    }

    const onClick = (e) => {
      e.stopPropagation()

      if (disabledOrCompleted) return false

      if (!confirming && this.props.confirm) {
        this.toggle(true) // if not confirming and we want to confirm, toggle to show confirmation
        return
      } else if (typeof this.props.callback === 'function') {
        this.setCompleted()
        this.props.callback(e)
      }

      confirming && this.toggle(false)
    }

    let classNames = {
      [classes[classBase]]: classes[classBase],
      [classes[`${classBase}--submitting`]]: this.props.submitting && classes[`${classBase}--submitting`],
      [classes[`${classBase}--disabled`]]: disabledOrCompleted && classes[`${classBase}--disabled`]
    }

    this.props.options.forEach((option) => {
      classNames[classes[`${classBase}--${option}`]] = classes[`${classBase}--${option}`]
    })

    const props = {
      className: cx(classNames),
      onClick,
      role: this.props.role,
      tabIndex: this.props.tabIndex || 0,

      // only link / submit / use input[for] when not disabled, completed and has been confirmed or doesn't need confirmation
      href: canComplete && this.props.href,
      to: canComplete && this.props.to,
      type: canComplete && this.props.submit && 'submit' || 'button',
      htmlFor: canComplete && this.props.htmlFor,

      disabled: disabledOrCompleted
    }

    Object.keys(props).forEach(key => {
      if (!props[key] && props[key] !== 0) delete props[key] // allow tabIndex=0, but delete all other falsey values
    })

    if (elementName === 'link' || elementName === 'a') elementName = Link

    return React.createElement(elementName, props, contents)
  },

  render: function () {
    if (this.props.stick) {
      return <Sticky
        {...this.props.stickOptions}
      >
        {this.renderButton()}
      </Sticky>
    }

    return this.renderButton()
  }
})

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js